// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__jtKF9","filesListContainer":"PosDisputesFiles_filesListContainer__2uECd","filesButton":"PosDisputesFiles_filesButton__1KssJ"};